import { useEffect, useState } from "react";
import { Offers as getOffersApi } from "../api/OffersApi";
import { Link } from "react-router-dom";
import Noimg from "../images/no_img.jpg";
import special_offer from "../images/offers/special_offer.png";
import { dateMonthYearFormatUtcToLocal } from "../utility/Constant";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import no_data from "images/no_data.png";
import moment from "moment";
import SEO from "components/headers/Seo";

export default function OffersPage({ configImages }) {
  const [offers, setOffers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [banner, setBanner] = useState("");       // eslint-disable-line

  useEffect(() => {
    getBanner();
    fetchOffers();
    // eslint-disable-next-line
  }, []);

  const getBanner = () => {
    configImages?.E_COMMERCE_BANNERS?.forEach((d) => {
      if (d.key === "offer") setBanner(d.value);
    });
  };

  const fetchOffers = () => {
    const date = `${moment().format("YYYY-MM-DD")}T00:00:00Z`;
    setLoading(true);
    getOffersApi({ validOffersDate: date, offerType: "MOBILE_OFFER" }).then(
      (data) => { setOffers(data.response.content); setLoading(false); },
      () => setLoading(false)
    );
  };

  const imgSrc = (item) =>
    item.offerImageString && item.offerImageString !== "" && item.offerImageString !== "-" && item.offerImageString !== "Image_Not_Available"
      ? item.offerImageString : Noimg;

  return (
    <div>
      <SEO title="Offers — AVM Jewellers" description="Latest offers and deals." name="AVM Jewellers" type="article" />

      {/* Banner */}
      {/* {banner ? (
        <div style={{ position: "relative", overflow: "hidden", maxHeight: 280 }}>
          <img src={banner} alt="Offers" style={{ width: "100%", objectFit: "cover", display: "block", maxHeight: 280 }} />
          <div style={{ position: "absolute", inset: 0, background: "linear-gradient(to right,rgba(0,0,0,.5) 0%,transparent 60%)", display: "flex", alignItems: "center", padding: "0 5%" }}>
            <div>
              <p style={{ margin: "0 0 6px", fontSize: 11, fontWeight: 700, letterSpacing: ".14em", textTransform: "uppercase", color: "var(--gold-300)" }}>AVM Jewellers</p>
              <h1 style={{ fontFamily: "var(--font-display)", fontSize: "clamp(32px,5vw,52px)", fontWeight: 500, color: "#fff", margin: 0 }}>Special Offers</h1>
            </div>
          </div>
        </div>
      ) : (
        <div style={{ background: "var(--surface-cream)", padding: "48px 0", textAlign: "center" }}>
          <p className="ej-section-eyebrow">Exclusive Deals</p>
          <h1 style={{ fontFamily: "var(--font-display)", fontSize: "clamp(32px,5vw,52px)", fontWeight: 500, color: "var(--ink-900)", margin: 0 }}>Special Offers</h1>
        </div>
      )} */}

      {/* Breadcrumb */}
      <div className="container">
        <div className="ej-breadcrumb">
          <Link to="/" className="ej-breadcrumb-link">Home</Link>
          <span className="ej-breadcrumb-sep">/</span>
          <span className="ej-breadcrumb-current">Offers</span>
        </div>
      </div>

      {/* Offers grid */}
      <section style={{ padding: "40px 0 80px" }}>
        <div className="container">
          {loading ? (
            <div className="row gy-4">
              {Array.from({ length: 6 }).map((_, i) => (
                <div key={i} className="col-sm-6 col-lg-4">
                  <div style={{ borderRadius: "var(--radius-lg)", overflow: "hidden", border: "1px solid var(--ink-100)" }}>
                    <Skeleton style={{ height: 240 }} />
                    <div style={{ padding: 16 }}>
                      <Skeleton height={14} style={{ marginBottom: 8, borderRadius: 4 }} />
                      <Skeleton height={12} width="60%" style={{ borderRadius: 4 }} />
                    </div>
                  </div>
                </div>
              ))}
            </div>
          ) : offers?.length === 0 ? (
            <div style={{ textAlign: "center", padding: "60px 0" }}>
              <img src={no_data} alt="No offers" style={{ maxWidth: 240, margin: "0 auto 16px" }} />
              <p style={{ fontSize: 15, color: "var(--ink-400)" }}>No active offers at the moment. Check back soon!</p>
            </div>
          ) : (
            <div className="row gy-4">
              {offers?.map((item, i) => (
                <div key={i} className="col-sm-6 col-lg-4">
                  <div style={{
                    borderRadius: "var(--radius-lg)", overflow: "hidden",
                    border: "1px solid var(--ink-100)", background: "#fff",
                    boxShadow: "var(--shadow-xs)",
                    transition: "transform .24s var(--ease-out),box-shadow .24s",
                  }}
                    onMouseEnter={e => { e.currentTarget.style.transform = "translateY(-4px)"; e.currentTarget.style.boxShadow = "var(--shadow-md)"; }}
                    onMouseLeave={e => { e.currentTarget.style.transform = "none"; e.currentTarget.style.boxShadow = "var(--shadow-xs)"; }}
                  >
                    <div style={{ position: "relative", overflow: "hidden" }}>
                      <img src={imgSrc(item)} alt={item.offerDetails} style={{ width: "100%", height: 240, objectFit: "cover", display: "block", transition: "transform var(--dur-slow) var(--ease-out)" }}
                        onMouseEnter={e => e.currentTarget.style.transform = "scale(1.04)"}
                        onMouseLeave={e => e.currentTarget.style.transform = "none"}
                      />
                      <div style={{ position: "absolute", top: 12, right: 12 }}>
                        <img src={special_offer} alt="offer" style={{ width: 44, height: 44 }} />
                      </div>
                    </div>

                    <div style={{ padding: "16px 20px" }}>
                      <h5 style={{ fontFamily: "var(--font-display)", fontSize: 18, fontWeight: 600, color: "var(--gold-500)", marginBottom: 6, textTransform: "capitalize" }}>
                        {item.offerDetails}
                      </h5>
                      {item.description && item.description !== "-" && item.description !== "" && (
                        <p style={{ fontSize: 13, color: "var(--ink-500)", lineHeight: 1.6, marginBottom: 12 }}>{item.description}</p>
                      )}
                      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", paddingTop: 12, borderTop: "1px solid var(--ink-100)" }}>
                        <div>
                          <p style={{ margin: 0, fontSize: 10.5, fontWeight: 600, letterSpacing: ".06em", textTransform: "uppercase", color: "var(--ink-400)" }}>Valid From</p>
                          <p style={{ margin: 0, fontSize: 12.5, fontWeight: 500, color: "var(--ink-700)" }}>{dateMonthYearFormatUtcToLocal(item.validFrom)}</p>
                        </div>
                        <div style={{ textAlign: "right" }}>
                          <p style={{ margin: 0, fontSize: 10.5, fontWeight: 600, letterSpacing: ".06em", textTransform: "uppercase", color: "var(--ink-400)" }}>Valid To</p>
                          <p style={{ margin: 0, fontSize: 12.5, fontWeight: 500, color: "var(--ink-700)" }}>{dateMonthYearFormatUtcToLocal(item.validTo)}</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      </section>
    </div>
  );
}